<script setup lang="ts">
import {NotificationTemplate as INotificationTemplate} from "@/notification-template/interfaces";
import NotificationTemplate from "@/notification-template/components/NotificationTemplate.vue";

defineProps<{
    template: INotificationTemplate
}>();
</script>

<template>
  <div class="border bg-muted rounded-lg p-6 flex flex-col gap-4 items-center">
    <p class="text-primary font-medium text-center">
      Aperçu du message
    </p>
    <NotificationTemplate :template="template" :show-name="false" class="max-w-sm" />
  </div>
</template>

<style scoped>

</style>
